import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import filterSearchIcon from './filter-search.svg';
import css from './show-filter.module.css';

interface Props {
  onClick: () => void;
  id?: string;
  defaultActiveValue?: boolean;
}

export default function ShowFilter({
  onClick,
  id = null,
  defaultActiveValue = false,
}: Props) {
  const { t } = useTranslation();
  const [active, setActive] = useState(defaultActiveValue);

  return (
    <div
      id={id}
      onClick={() => {
        onClick();
        setActive(!active);
      }}
      className={css['container']}
    >
      <img src={filterSearchIcon} alt="" />
      <h1
        className={`${css['filter-text']} ${
          active && css['filter-text-active']
        }`}
      >
        {t('pages.warehouse.movement.filter')}
      </h1>
    </div>
  );
}
